// const API_BASE_URL = 'http://localhost:5000/api';
const API_BASE_URL = 'https://ccbackendserver1.vercel.app/api';

class ApiError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}

// Recruitment form submission
export const submitRecruitmentForm = async (formData) => {
    try {
        const form = new FormData();
        Object.keys(formData).forEach(key => {
            if (key !== 'resume') {
                form.append(key, formData[key]);
            }
        });
        if (formData.resume) {
            form.append('resume', formData.resume);
        }

        const response = await fetch(`${API_BASE_URL}/careers/recruitment`, {
            method: 'POST',
            body: form
        });
        
        const data = await response.json();
        if (!response.ok) {
            if (response.status === 409) {
                throw new ApiError(
                    'Application already submitted with this phone number or email!',
                    response.status
                );
            }
            throw new ApiError(
                data.message || data.errors?.[0] || 'Failed to submit application. Please try again later.',
                response.status
            );
        }
        return data;
    } catch (error) {
        if (error instanceof ApiError) {
            throw error;
        }
        throw new ApiError(
            'Server error. Please try again later.',
            500
        );
    }
};

// Contact form submission
export const submitContactForm = async (formData) => {
    try {
        const response = await fetch(`${API_BASE_URL}/contact/submit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        
        const data = await response.json();
        if (!response.ok) {
            throw new ApiError(
                data.message || 'Failed to submit form. Please try again later.',
                response.status
            );
        }
        return data;
    } catch (error) {
        if (error instanceof ApiError) {
            throw error;
        }
        throw new ApiError(
            'Server error. Please try again later.',
            500
        );
    }
};

// Quote form submission
export const submitQuoteForm = async (formData) => {
    try {
        const response = await fetch(`${API_BASE_URL}/quote/submit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        
        const data = await response.json();
        if (!response.ok) {
            throw new ApiError(
                data.message || 'Failed to submit quote request. Please try again later.',
                response.status
            );
        }
        return data;
    } catch (error) {
        if (error instanceof ApiError) {
            throw error;
        }
        throw new ApiError(
            'Server error. Please try again later.',
            500
        );
    }
};

// Career application submission
export const submitCareerApplication = async (formData) => {
    try {
        const form = new FormData();
        
        // Append all text fields
        Object.keys(formData).forEach(key => {
            if (key !== 'resume') {
                form.append(key, formData[key]);
            }
        });
        
        // Append resume file if exists
        if (formData.resume) {
            form.append('resume', formData.resume);
        }

        const response = await fetch(`${API_BASE_URL}/careers/submit`, {
            method: 'POST',
            body: form
        });
        
        const data = await response.json();
        if (!response.ok) {
            throw new ApiError(
                data.message || 'Failed to submit application. Please try again later.',
                response.status
            );
        }
        return data;
    } catch (error) {
        if (error instanceof ApiError) {
            throw error;
        }
        throw new ApiError(
            'Server error. Please try again later.',
            500
        );
    }
};

export default {
    submitRecruitmentForm,
    submitContactForm,
    submitQuoteForm,
    submitCareerApplication
};